<template>
  <div id="main_div">
    <FeatureService/>
    <!-- sign up -->
    <!--blog Section end-->
    <OperationModel/>
    <Technologic/>
    <RecallForm/>
    <Map/>
    <!-- Footer Section start -->
    <Footer/>
    <!-- Footer Section End -->
    <js/>
  </div>
</template>
<script>
export default {
  name: 'Service',
  beforeCreate: function () {
    document.body.className = ''
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/service_page.vue